/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/servicePrincipalsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a ServicePrincipals. */
var ServicePrincipals = /** @class */ (function () {
    /**
     * Create a ServicePrincipals.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function ServicePrincipals(client) {
        this.client = client;
    }
    ServicePrincipals.prototype.create = function (parameters, options, callback) {
        return this.client.sendOperationRequest({
            parameters: parameters,
            options: options
        }, createOperationSpec, callback);
    };
    ServicePrincipals.prototype.list = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOperationSpec, callback);
    };
    ServicePrincipals.prototype.update = function (objectId, parameters, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            parameters: parameters,
            options: options
        }, updateOperationSpec, callback);
    };
    ServicePrincipals.prototype.deleteMethod = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, deleteMethodOperationSpec, callback);
    };
    ServicePrincipals.prototype.get = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, getOperationSpec, callback);
    };
    ServicePrincipals.prototype.listOwners = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, listOwnersOperationSpec, callback);
    };
    ServicePrincipals.prototype.listKeyCredentials = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, listKeyCredentialsOperationSpec, callback);
    };
    ServicePrincipals.prototype.updateKeyCredentials = function (objectId, value, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            value: value,
            options: options
        }, updateKeyCredentialsOperationSpec, callback);
    };
    ServicePrincipals.prototype.listPasswordCredentials = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, listPasswordCredentialsOperationSpec, callback);
    };
    ServicePrincipals.prototype.updatePasswordCredentials = function (objectId, value, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            value: value,
            options: options
        }, updatePasswordCredentialsOperationSpec, callback);
    };
    ServicePrincipals.prototype.listNext = function (nextLink, options, callback) {
        return this.client.sendOperationRequest({
            nextLink: nextLink,
            options: options
        }, listNextOperationSpec, callback);
    };
    ServicePrincipals.prototype.listOwnersNext = function (nextPageLink, options, callback) {
        return this.client.sendOperationRequest({
            nextPageLink: nextPageLink,
            options: options
        }, listOwnersNextOperationSpec, callback);
    };
    return ServicePrincipals;
}());
export { ServicePrincipals };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createOperationSpec = {
    httpMethod: "POST",
    path: "{tenantID}/servicePrincipals",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: "parameters",
        mapper: __assign(__assign({}, Mappers.ServicePrincipalCreateParameters), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.ServicePrincipal
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/servicePrincipals",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.filter,
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ServicePrincipalListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var updateOperationSpec = {
    httpMethod: "PATCH",
    path: "{tenantID}/servicePrincipals/{objectId}",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: "parameters",
        mapper: __assign(__assign({}, Mappers.ServicePrincipalUpdateParameters), { required: true })
    },
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var deleteMethodOperationSpec = {
    httpMethod: "DELETE",
    path: "{tenantID}/servicePrincipals/{objectId}",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var getOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/servicePrincipals/{objectId}",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ServicePrincipal
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOwnersOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/servicePrincipals/{objectId}/owners",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listKeyCredentialsOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/servicePrincipals/{objectId}/keyCredentials",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.KeyCredentialListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var updateKeyCredentialsOperationSpec = {
    httpMethod: "PATCH",
    path: "{tenantID}/servicePrincipals/{objectId}/keyCredentials",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: {
            value: "value"
        },
        mapper: __assign(__assign({}, Mappers.KeyCredentialsUpdateParameters), { required: true })
    },
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listPasswordCredentialsOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/servicePrincipals/{objectId}/passwordCredentials",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.PasswordCredentialListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var updatePasswordCredentialsOperationSpec = {
    httpMethod: "PATCH",
    path: "{tenantID}/servicePrincipals/{objectId}/passwordCredentials",
    urlParameters: [
        Parameters.objectId,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: {
            value: "value"
        },
        mapper: __assign(__assign({}, Mappers.PasswordCredentialsUpdateParameters), { required: true })
    },
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listNextOperationSpec = {
    httpMethod: "GET",
    path: "{tenantID}/{nextLink}",
    urlParameters: [
        Parameters.nextLink,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.ServicePrincipalListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
var listOwnersNextOperationSpec = {
    httpMethod: "GET",
    baseUrl: "https://graph.windows.net",
    path: "{nextLink}",
    urlParameters: [
        Parameters.nextPageLink
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.GraphError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=servicePrincipals.js.map